<template>
  <div>
    <Banner />
    <Visit />
    <Reports />
    <Release />
    <OwFooter />
  </div>
</template>
<script>
import Banner from './components/banner'
import Visit from './components/visit'
import Reports from './components/reports'
import Release from './components/release'
import OwFooter from '@/components/ow-footer'
export default {
  name: 'news-center',
  components: {
    Banner,
    Visit,
    Reports,
    Release,
    OwFooter
  }
}
</script>
